import React from 'react';
import styles from './XRayCaptureDiagram.module.css';
import diagram from './xray-capture-diagram.png';

export const XRayCaptureDiagram = () => (
  <div className={styles.container}>
    <div className={styles.header}>
      <div className={styles.h1}>Click, Capture & Convert </div>
      <div className={styles.column}>
        <span>Supercharge your email revenue by 7X.</span>
        <span>
          {' '}
          Restore your ad retargeting audiences to pre iOS 14 levels.
        </span>
        <span>Grow your email list.</span>
      </div>
    </div>
    <img src={diagram} className={styles.image} />
    <div className={styles.text}>
      * Based on traffic estimates and average X-Ray visitor identification
      rate.
    </div>
  </div>
);
